import styles from "./Treatment.module.css";
import { FiPlus, FiSave } from "react-icons/fi";
import { useFeatureFlipStore } from "Store/featureFlipStore";
import ExistingTreatmentCard from "./ExistingTreatmentCard/ExistingTreatmentCard";
import NewTreatmentCard from "./NewTreatmentCard/NewTreatmentCard";
import { useHandleTreatments } from "hooks/useHandleTreatments";
import { useEffect, useState } from "react";
import { getNextAvailableColor } from "Utils/utils";

const Treatment = () => {
  const {
    newTreatments,
    editedTreatments,
    deletedTreatments,
    existingTreatments,
  } = useFeatureFlipStore();

  const {
    handleAddTreatment,
    handleRemoveTreatment,
    handleTreatmentChange,
    handleSaveTreatment,
  } = useHandleTreatments();

  const [hasChanges, setHasChanges] = useState(false);

  useEffect(() => {
    if (newTreatments.length || deletedTreatments.length) {
      setHasChanges(true);
      return;
    }
    const existing = JSON.stringify(existingTreatments);
    const edited = JSON.stringify(editedTreatments);
    if (existing !== edited) {
      setHasChanges(true);
    } else setHasChanges(false);
  }, [existingTreatments, editedTreatments, newTreatments, deletedTreatments]);

  return (
    <div className={styles.section}>
      <h2>Treatments</h2>
      <div className={styles.card}>
        <div className={styles.treatmentList}>
          {editedTreatments.map((treatment, index) => (
            <ExistingTreatmentCard
              key={`existing_${index}`}
              treatment={treatment}
              index={index}
              handleTreatmentChange={handleTreatmentChange}
              handleRemoveTreatment={handleRemoveTreatment}
            />
          ))}

          {newTreatments.map((treatment, index) => (
            <NewTreatmentCard
              key={`new_${index}`}
              treatment={treatment}
              index={index}
              handleTreatmentChange={handleTreatmentChange}
              handleRemoveTreatment={handleRemoveTreatment}
            />
          ))}
        </div>
        <div className={styles.buttonContainer}>
          <button className={styles.addButton} onClick={handleAddTreatment}>
            <FiPlus /> Add new treatment
          </button>
          {hasChanges && (
            <button onClick={handleSaveTreatment} className={styles.saveButton}>
              <FiSave /> Save Changes
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default Treatment;
